import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BUSINESS } from "@/lib/constants";

export const FundingEducation = () => (
  <section data-testid="funding-education-section" className="bg-[#08080A] py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#D8B54A]" data-testid="funding-education-label">
          Funding Education
        </p>
        <h2
          data-testid="funding-education-heading"
          className="mt-3 font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl"
        >
          Funding Starts With Preparation.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[#C6C0B4] sm:text-lg">
          Access to financing depends on many factors, including lender requirements,
          creditworthiness, financial history, documentation, business performance and other
          eligibility standards.
        </p>
        <p className="mt-4 text-base leading-relaxed text-[#C6C0B4] sm:text-lg">
          J11 helps clients better understand these factors and prepare themselves before pursuing
          financing opportunities.
        </p>
        <p className="mt-4 text-sm font-medium leading-relaxed text-[#8D877B] sm:text-base" data-testid="funding-education-note">
          {BUSINESS.shortName} does not make lending decisions and does not guarantee approval from
          any lender or financial institution.
        </p>
        <Link
          to="/#consultation"
          data-testid="funding-education-cta"
          className="group mt-8 inline-flex h-12 items-center justify-center gap-2 rounded-lg bg-gradient-to-b from-[#E7C766] to-[#AE8924] px-8 text-sm font-semibold text-black shadow-lg shadow-[#C9A227]/25 transition-colors duration-200 hover:from-[#F2D47E] hover:to-[#C49B2E]"
        >
          Start With a Free Consultation
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);
